import axios from './api-client'
import { Submission, SubmissionFileType, FileMetadata, EditorialOffice } from '@/types'

export interface StartSubmissionResponse {
  submissionId: string
  token: string
}

export default {
  getEditorialOfficeIds: function () {
    return axios.get<EditorialOffice[]>('/editorialOffice')
  },
  startNewSubmission: function () {
    return axios.post<StartSubmissionResponse>('/submission')
  },
  continueSubmission: function (submissionId: string) {
    return axios.post<{ token: string }>(`/submission/${submissionId}/continue`)
  },
  addFile: function (submissionId: string, file: File, fileType: SubmissionFileType) {
    var url = `/submission/${submissionId}/file`

    var formData = new FormData()
    formData.append('file', file)
    formData.append('fileType', fileType)

    var config = {
      headers: { 'Content-Type': 'multipart/form-data' },
    }

    return axios.post<FileMetadata>(url, formData, config)
  },
  deleteFile: function (submissionId: string, fileId: string) {
    return axios.delete(`/submission/${submissionId}/file/${fileId}`)
  },
  finaliseSubmission: function (submission: Submission) {
    return axios.post(`/submission/${submission.submissionId}`, submission)
  },
  addCustomDas: function (submissionId: string, content: string, fileType: SubmissionFileType) {
    var formData = new FormData()
    formData.append('fileType', fileType)
    formData.append('dasContent', content)

    var config = {
      headers: { 'Content-Type': 'multipart/form-data' },
    }

    return axios.post<FileMetadata>(`/submission/${submissionId}/AddCustomDAS`, formData, config)
  },
  addNoDataDas: function (submissionId: string, fileType: SubmissionFileType) {
    var formData = new FormData()
    formData.append('fileType', fileType)

    return axios.post<FileMetadata>(`/submission/${submissionId}/AddNoDataDAS`, formData)
  },
}
